import { render, staticRenderFns } from "./OrderSelector.vue?vue&type=template&id=cd56483a&scoped=true&"
import script from "./OrderSelector.vue?vue&type=script&lang=js&"
export * from "./OrderSelector.vue?vue&type=script&lang=js&"
import style0 from "./OrderSelector.vue?vue&type=style&index=0&id=cd56483a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd56483a",
  null
  
)

export default component.exports